import React from 'react'
import { ButtonPrimary, ButtonSpan } from "../../../../../Components/Button";
import Modal from "../../../../../Components/Modal";
import VenueFinancialsForm from "../../../EditVenue/Financials/VenueFinancialForm";
let InvoiceBillingAddressModal = ({event, form, countries, onSubmit, onClose}) => {


  return (
    <Modal>
      <div className="modal">
        <div className="modal-inner font-bold">
          <div>
            <h1>Update {event?.venue?.name}'s Invoice Billing Address</h1>

            <ButtonSpan
              className="m-3 absolute pin-t pin-r z-10"
              onClick={onClose}
            >
              <i className="fas fa-times-circle fa-2x ml-3" />
            </ButtonSpan>
          </div>
          <VenueFinancialsForm
            form={form}
            countries={countries}
            onSubmit={onSubmit}
            hideEmail={true}
            isModal={true}
            venue={event?.venue}
          />
        </div>
      </div>
    </Modal>
  )



}




export default InvoiceBillingAddressModal;